<mat-card appearance="outlined">
  <mat-card-header>
    <img mat-card-avatar class="accessory-box-img"
      [src]="'/files/filling/' + (pageData.filling?.image || '')"
      [alt]="pageData.filling?.name"
      defaultImg>
      <mat-card-title class="accessory-box-title">{{pageData.filling?.name}}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="panel-type">
        @if (pageData.filling?.type !== 'door_panels') {
          @for (filling of pageData.filteredFillings; track filling) {
            @switch (filling.panel_type) {
              @case ('panel_type_inset') {
                <div matRipple (click)="setPanelType('Inset', filling)" [class.selected]="filling.id === selectedFilling.id">
                  <div class="img">
                    <img src="/application/dist/web/img/layouts/default/panel1.png">
                  </div>
                  <p><a>{{'DOOR|Wypełnienie wsadowe' | translate}} ({{filling.thickness_mm | unitmm:1:1}})</a></p>
                </div>
              }
              @case ('panel_type_outer') {
                <div matRipple (click)="setPanelType('Outer', filling)" [class.selected]="filling.id === selectedFilling.id">
                  <div class="img">
                    <img src="/application/dist/web/img/layouts/default/panel2.png">
                  </div>
                  <p><a>{{'DOOR|Nakładka zewnętrzna' | translate}} ({{filling.thickness_mm | unitmm:1:1}})</a></p>
                </div>
              }
              @case ('panel_type_double') {
                <div matRipple (click)="setPanelType('Double', filling)" [class.selected]="filling.id === selectedFilling.id">
                  <div class="img">
                    <img src="/application/dist/web/img/layouts/default/panel3.png">
                  </div>
                  <p><a>{{'DOOR|Nakładka obustronna' | translate}} ({{filling.thickness_mm | unitmm:1:1}})</a></p>
                </div>
              }
              @case ('panel_type_inner') {
                <div matRipple (click)="setPanelType('Inner', filling)" [class.selected]="filling.id === selectedFilling.id">
                  <div class="img">
                    <img src="/application/dist/web/img/layouts/default/panel4.png">
                  </div>
                  <p><a>{{'DOOR|Nakładka wewnętrzna' | translate}} ({{filling.thickness_mm | unitmm:1:1}})</a></p>
                </div>
              }
            }
          }
        }
      </div>
      @if (pageData.filling?.panel_glazings_ids?.length > 0) {
        <icc-select-box [title]="panelGlazingBox?.title"
            [disabledButton1]="isPanelGlazingSelectionDisabled()"
          [description]="panelGlazingBox?.name"
          [imageUrl]="panelGlazingBox?.img"
          [buttonText]="'INTERFACE|Zmień' | translate"
          [descriptionTemplate]="panelGlazingBoxTemplate"
          [descriptionContext]="{box: panelGlazingBox}"
          (select)="changePanelGlazing()"
        ></icc-select-box>
      }
      @if (pageData.filling?.doorPanelTrimsOutside?.length > 0) {
        <icc-select-box [title]="'DOOR|Listwa dekoracyjna zewnętrzna' | translate"
            [disabledButton1]="isPanelTrimSelectionDisabled('outside')"
          [description]="selectedPanelTrim?.name"
          [imageUrl]="selectedPanelTrim?.image ? ('/files/doorpaneltrim/' + selectedPanelTrim?.image) :''"
          [buttonText]="'INTERFACE|Zmień' | translate"
          (select)="changePanelTrim('outside')"
        ></icc-select-box>
      }
      @if (pageData.filling?.doorPanelTrimsInside?.length > 0) {
        <icc-select-box [title]="'DOOR|Listwa dekoracyjna wewnętrzna' | translate"
            [disabledButton1]="isPanelTrimSelectionDisabled('inside')"
          [description]="selectedInnerPanelTrim?.name"
          [imageUrl]="selectedInnerPanelTrim?.image ? ('/files/doorpaneltrim/' + selectedInnerPanelTrim?.image) :''"
          [buttonText]="'INTERFACE|Zmień' | translate"
          (select)="changePanelTrim('inside')"
        ></icc-select-box>
      }
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button color="primary" (click)="save()"
      >{{ 'INTERFACE|OK' | translate }}</button>
    </mat-card-actions>
  </mat-card>

  <ng-template #panelGlazingBoxTemplate let-box="box">
    <p class="glassTypeDescription">
      {{box.name}}<br>
      U<sub>g</sub> = {{box.u}}
    </p>
  </ng-template>

